import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/badge";
import type { IUserGroup } from "@/apis/users/getMe";

interface GroupBadgeProps {
  group?: IUserGroup | null;
  className?: string;
}

const GroupBadge: React.FC<GroupBadgeProps> = ({ group, className }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // 부모 요소의 클릭 이벤트 방지
    if (group?.id) {
      navigate(`/groups/${group.id}`);
    }
  };

  if (!group) {
    return <span className={`text-zinc-500 ${className || ""}`}>-</span>;
  }

  return (
    <Badge
      color="zinc"
      className={`cursor-pointer hover:bg-zinc-200 transition-colors ${
        className || ""
      }`}
      onClick={handleClick}
    >
      {group.name}
    </Badge>
  );
};

export default GroupBadge;
